import React, { Component } from 'react'
import { connect } from 'react-redux'
import SideSearchbar from '../../components/SideSearchbar/'
import { GetProjects, GetProjectData, GetUserForManager, EditProject, CreateNewProject, DeleteProject, GetUserAccessRight, GetConsultantCost } from './ProjectsAction'
import { Typography, Snackbar, Card, Tabs, Tab, Container, Grid, Button, TextField, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog } from '@material-ui/core';
import isEmpty from 'lodash.isempty';
import OverLoader from '../../components/common/loader';
import '../../App.css'
import moment from 'moment'
import ProjectForm from './ProjectForm';
import SecondTab from './SecondTab';
import CapacityPlanning from './CapacityPlanning'
import Consultants from './Consultants';
import Planning from './Planning';
import Invoices from './Invoices';
import Activity from './Activity';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import { LogoutAction, GetCustomer } from '../../actions';
import { GetSystem } from '../Systems/SystemsAction';
import { GetBranches } from '../Branches/branchesAction'
import { Prompt, withRouter } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Card className="p-40">{children}</Card>}
    </Typography>
  );
}

class Projects extends Component {

  constructor(props) {
    super(props);
    this.state = {
      projectId: '',
      loginErrors: false,
      isBlocking: false,
      projekt: '',
      currentTab: 0,
      listData: [],
      projectNumber: '',
      externIntern: "0",
      active: true,
      projectName: '',
      kunde: '',
      branche: '',
      managment: '',
      projectManagement: '',
      projectmanager: '',
      probability: '',
      dailyProof: 0,
      toleranceRegistering: '',
      toleranceregisteringError: false,
      reference: 0,
      tolerancePlanning: '',
      secret: 0,
      hoursperday: '',
      archived: '',
      comment: '',
      shortcut: '',
      invoiceaddress: '',
      isDeleteContactDialogOpen: false,
      newProject: '',
      deletedProject: '',
      editedProject: '',
      errorMessage: '',
      ProjectFunctionsAndFee: false,
      archivedError: false,
      forOwn: false,
      forOther: false,
      sideBarDrawer: true,
      hasPmAccess: true,
      urlProjectNo: '',
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const { forOther, forOwn, currentTab } = this.state
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')

    if (Number(access_rights.projects_basedata_for_own) === 2 || Number(access_rights.projects_basedata_for_other) === 2) {
      if (currentTab === 0 && token !== null)
        this.textInput.current.focus();
    } else if (Number(access_rights.projects_basedata_for_own) === 0 && Number(access_rights.projects_basedata_for_other) === 0) {
      if ((Number(access_rights.projects_fee_for_other) === 0 && forOther) || (Number(access_rights.projects_fee_for_own) === 0 && forOther === false && forOwn === false) || (Number(access_rights.projects_fee_for_own) === 0 && forOwn)) {
        if ((Number(access_rights.projects_capacity_for_other) === 0 && forOther) || (Number(access_rights.projects_capacity_for_own) === 0 && forOther === false && forOwn === false) || (Number(access_rights.projects_capacity_for_own) === 0 && forOwn)) {
          if ((Number(access_rights.projects_consultants_for_other) === 0 && forOther) || (Number(access_rights.projects_consultants_for_own) === 0 && forOther === false && forOwn === false) || (Number(access_rights.projects_consultants_for_own) === 0 && forOwn)) {
            if ((Number(access_rights.projects_planning_for_other) === 0 && forOther) || (Number(access_rights.projects_planning_for_own) === 0 && forOther === false && forOwn === false) || (Number(access_rights.projects_planning_for_own) === 0 && forOwn)) {
              if ((Number(access_rights.projects_invoices_for_other) === 0 && forOther) || (Number(access_rights.projects_invoices_for_own) === 0 && forOther === false && forOwn === false) || (Number(access_rights.projects_invoices_for_own) === 0 && forOwn)) {
                if ((Number(access_rights.projects_activity_for_other) === 0 && forOther) || (Number(access_rights.projects_activity_for_own) === 0 && forOther === false && forOwn === false) || (Number(access_rights.projects_activity_for_other) === 0 && forOwn)) {
                } else
                  this.handleTabChange("", 6, "true")
              } else
                this.handleTabChange("", 5, "true")
            } else
              this.handleTabChange("", 4, "true")
          } else
            this.handleTabChange("", 3, "true")
        }
        else
          this.handleTabChange("", 2, "true")
      } else
        this.handleTabChange("", 1, "true")
    } else
      this.handleTabChange("", 0, "true")
  }

  componentDidMount = () => {
    const { GetProjects, GetUserForManager, GetSystem, GetCustomer, GetBranches } = this.props
    GetProjects()
    GetUserForManager()
    GetSystem("project")
    GetCustomer()
    GetBranches()
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    if (Number(access_rights.projects_basedata_for_own) === 0) {
      this.focusTextInput()
    }
    const { projectno } = this.props.match.params
    if (projectno) {
      this.setState({ urlProjectNo: projectno })
    }
  }
  handleTabChange = (e, newTabIndex, mount) => {
    const { editMode, isBlocking } = this.state
    if (editMode || mount)
      if (!isBlocking)
        this.setState({ currentTab: newTabIndex })
      else {
        let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

        if (retVal === true) {
          this.setState({ isBlocking: false, currentTab: newTabIndex })
        } else {
          this.setState({ isBlocking: false }, () => setTimeout(() => {
            this.setState({ isBlocking: true })
          }, 100))
        }
      }

  }
  isBlockingCheck = () => {
    this.setState({ isBlocking: true })
  }
  isBlockingCheckfalse = () => {
    this.setState({ isBlocking: false })
  }

  handleFieldsChange = (e, key) => {
    const { dailyProof, reference, secret, comment, editMode } = this.state
    const { project_data } = this.props
    this.setState({ isBlocking: true })
    if (key === "projectNumber") {
      this.setState({ projectNumber: e.target.value })
    } else if (key === "externIntern") {
      if (editMode && e.target.value === "0") {
        this.setState({ projectNumber: project_data.project.projectno, externIntern: e.target.value })
      } else if (e.target.value === "0")
        this.setState({ externIntern: e.target.value, projectNumber: '' })
      else
        this.setState({ externIntern: e.target.value })
    }
    else if (key === "active") {
      this.setState({ active: !this.state.active })
    }
    else if (key === "Projektname") {
      this.setState({ projectName: e.target.value })
    }
    else if (key === "shortcut") {
      this.setState({ shortcut: e.target.value })
    }
    else if (key === "kunde") {
      this.setState({ kunde: e.target.value })
    }
    else if (key === "branche") {
      this.setState({ branche: e.target.value })
    }
    else if (key === "managment") {
      this.setState({ managment: e.target.value })
    }
    else if (key === "projectmanagement") {
      this.setState({ projectManagement: e.target.value })
    }
    else if (key === "projectmanager") {
      this.setState({ projectmanager: e.target.value, hasPmAccess: e.target.value.has_pm_access })
    }
    else if (key === "probability") {
      this.setState({ probability: e.target.value })
    }
    else if (key === "dailyproof") {
      let newdailyProof
      if (dailyProof === 0) {
        newdailyProof = 1
      } else {
        newdailyProof = 0
      }
      this.setState({ dailyProof: newdailyProof })
    }
    else if (key === "toleranceregistering") {
      this.setState({ toleranceRegistering: e.target.value, toleranceregisteringError: false })
    }
    else if (key === "reference") {
      let newreference
      if (reference === 0) {
        newreference = 1
      } else {
        newreference = 0
      }
      this.setState({ reference: newreference })
    }
    else if (key === "toleranceplanning") {
      this.setState({ tolerancePlanning: e.target.value })
    }
    else if (key === "secret") {
      let newsecret
      if (secret === 0) {
        newsecret = 1
      } else {
        newsecret = 0
      }
      this.setState({ secret: newsecret })
    }
    else if (key === "hoursperday") {
      this.setState({ hoursperday: e.target.value })
    }
    else if (key === "archived") {
      if (e !== null) {
        let date = moment(e._d).format("DD.MM.YYYY");
        this.setState({ archived: date })
      } else {
        this.setState({ archived: '' })
      }
    }
    else if (key === "comment") {
      let commentAppend
      let date = new Date()

      let user = JSON.parse(localStorage.getItem('user'))
      if (comment === '') {
        commentAppend = moment(date).format("DD.MM.YYYY") + " / " + user.loginname + " / " + e
      } else {
        commentAppend = comment + "\n" + moment(date).format("DD.MM.YYYY") + " / " + user.loginname + " / " + e
      }
      this.setState({ comment: commentAppend })
    }
    else if (key === "invoiceaddress") {
      this.setState({ invoiceaddress: e.target.value })
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { projects_list, new_project, login_error, edited_project, delete_success, project_data, error_validation, system_settings } = this.props
    const { projectId, editMode } = this.state

    if (nextProps.projects_list !== projects_list) {
      this.setState({ listData: nextProps.projects_list })
      const { urlProjectNo } = this.state
      if (urlProjectNo) {
        const match = nextProps.projects_list.find(p => String(p.projectno) === String(urlProjectNo))
        if (match) {
          this.setState({ urlProjectNo: '' })
          this.getProjectsData(match)
        }
      }
    } if (nextProps.error_validation !== error_validation) {
      this.setState({ errorMessage: nextProps.error_validation })
    }
    if (nextProps.project_data !== project_data) {
      nextProps.forown_list.map(i => {
        if (nextProps.project_data.project.id === i) {
          this.setState({ forOwn: true, forOther: false })
        }
      })
      nextProps.forother_list.map(i => {
        if (nextProps.project_data.project.id === i) {
          this.setState({ forOwn: false, forOther: true })
        }
      })
      this.setState({
        editMode: true,
        isBlocking: false,
        projectId: nextProps.project_data.project.id,
        projectmanager: nextProps.project_data.project.project_manager_id,
        active: nextProps.project_data.project.active,
        externIntern: nextProps.project_data.project.internal !== null ? nextProps.project_data.project.internal.toString() : "1",
        managment: nextProps.project_data.project.management,
        archived: nextProps.project_data.project.archived !== null ? moment(nextProps.project_data.project.archived).format("DD.MM.YYYY") : '',
        comment: nextProps.project_data.project.comment !== null ? nextProps.project_data.project.comment : '',
        kunde: nextProps.project_data.project.customer_id,
        branche: nextProps.project_data.project.branch_id,
        dailyProof: nextProps.project_data.project.dailyproof,
        hoursperday: nextProps.project_data.project.hoursperday !== null ? nextProps.project_data.project.hoursperday.toString().replace(".", ",") : nextProps.project_data.project.hoursperday,
        invoiceaddress: nextProps.project_data.project.invoiceaddress,
        management: nextProps.project_data.project.management,
        shortcut: nextProps.project_data.project.shortcut !== null ? nextProps.project_data.project.shortcut : '',
        projectManagement: nextProps.project_data.project.projectmanagement,
        probability: nextProps.project_data.project.probability,
        projectName: nextProps.project_data.project.projectname,
        projekt: nextProps.project_data.project.projectno + ' / ' + nextProps.project_data.project.projectname,
        projectNumber: nextProps.project_data.project.projectno,
        reference: nextProps.project_data.project.reference,
        secret: nextProps.project_data.project.secret,
        tolerancePlanning: nextProps.project_data.project.toleranceplaning,
        toleranceRegistering: nextProps.project_data.project.toleranceregistering,
      }, () => this.focusTextInput()
      )
    }
    if (nextProps.new_project !== new_project) {
      this.setState({ newProject: nextProps.new_project, isBlocking: false, projectId: nextProps.new_project.id, projekt: nextProps.new_project.name, editMode: true })
    }
    if (nextProps.login_error !== login_error) {
      this.setState({ loginErrors: true })
    }
    if (nextProps.system_settings !== system_settings && !editMode) {
      let planing = nextProps.system_settings.toleranceplaning
      let registering = nextProps.system_settings.toleranceregistering
      let hours = Number(nextProps.system_settings.hoursperday)

      this.setState({
        toleranceRegistering: registering,
        tolerancePlanning: planing,
        hoursperday: hours
      })
    }

    if (nextProps.edited_project !== edited_project) {
      this.setState({
        editedProject: nextProps.edited_project,
        isBlocking: false,
        projekt: nextProps.edited_project.projectno + ' / ' + nextProps.edited_project.name,
      })
    } if (nextProps.delete_success !== delete_success) {
      this.setState({ deletedProject: projectId, isBlocking: false })
    }
  }

  getProjectsData = (item) => {
    const { GetProjectData } = this.props
    const { isBlocking } = this.state
    if (!isBlocking) {
      this.resetForm("get")
      GetProjectData(item.id)
    }
    else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getProjectsData(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }

  createProject = () => {
    const { CreateNewProject, EditProject } = this.props
    const dataObj = this.state

    if (dataObj.editMode) {
      if (dataObj.currentTab === 0) {
        EditProject(dataObj)
      } else {
        this.setState({ ProjectFunctionsAndFee: true })
        setTimeout(() => {
          this.setState({ ProjectFunctionsAndFee: false })
        })
      }
    }
    else {
      CreateNewProject(dataObj)
    }
  }

  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })
  }

  deleteProject = () => {
    const { DeleteProject } = this.props
    const { projectId } = this.state
    DeleteProject(projectId)
    this.resetForm()
  }

  resetForm = (val) => {
    const { system_settings } = this.props
    this.baseState.listData = this.props.projects_list;
    this.baseState.editedProject = this.props.edited_project;
    this.baseState.newProject = this.props.new_project;
    this.baseState.editMode = false;
    this.baseState.projectId = this.state.projectId;
    if (val !== 'get') {
      this.baseState.toleranceRegistering = system_settings.toleranceregistering;
      this.baseState.tolerancePlanning = system_settings.toleranceplaning;
      this.baseState.hoursperday = Number(system_settings.hoursperday);
      setTimeout(() => {
        this.focusTextInput()
      }, 100)
    }
    this.setState(this.baseState)
  }

  render() {
    const dataObj = this.state
    const { isloading, user_list_for_pm, login_error, customer_list, branches_list, consultant_list, project_data } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <div container="true" spacing={3} className={`mainBlock mainslideblock ${dataObj.sideBarDrawer ? "" : "mainBlock-wide"}`}>
            <div className={`sidebar-left ${dataObj.sideBarDrawer ? "" : "close"}`}>
              <button className="actionButton">
                <ArrowLeftIcon onClick={() => this.setState({ sideBarDrawer: !dataObj.sideBarDrawer })}></ArrowLeftIcon>
              </button>

              <div className="leftSide">
                <SideSearchbar
                  tittle={"Neues Projekt"}
                  listData={dataObj.listData}
                  newList={dataObj.newProject}
                  editedList={dataObj.editedProject}
                  deleteList={dataObj.deletedProject}
                  getDataOfSelectedItemFunc={this.getProjectsData}
                  createNewListFunc={this.resetForm}
                  activeField={true}
                  internExtern={true}
                  isRight={(Number(access_rights.projects_basedata_for_own) === 2 || Number(access_rights.projects_basedata_for_other) === 2) ? 2 : 0}
                />
              </div>
            </div>
            <div className="mainContent">
              <div className="rightBlock liproCard">
                <div className="mb2">
                  <span style={{
                    display: 'inline-flex',
                    padding: '10px',
                    fontSize: '18px'
                  }}>Projekt</span>
                  <TextField disabled size="small" value={dataObj.projekt} className="innerInput" variant="outlined" />
                </div>
                <Tabs
                  value={dataObj.currentTab}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary">
                  <Tab label="Projektstammdaten" style={Number(access_rights.projects_basedata_for_own) === 0 && Number(access_rights.projects_basedata_for_other) === 0 ? { display: "none" } : {}} />
                  <Tab label="Honorare" style={(Number(access_rights.projects_fee_for_other) === 0 && dataObj.forOther) || (Number(access_rights.projects_fee_for_own) === 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_fee_for_own) === 0 && dataObj.forOwn) ? { display: "none" } : {}} />
                  <Tab label="Kapazitätsplanung" style={(Number(access_rights.projects_capacity_for_other) === 0 && dataObj.forOther) || (Number(access_rights.projects_capacity_for_own) === 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_capacity_for_own) === 0 && dataObj.forOwn) ? { display: "none" } : {}} />
                  <Tab label="Berater" style={(Number(access_rights.projects_consultants_for_other) === 0 && dataObj.forOther) || (Number(access_rights.projects_consultants_for_own) === 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_consultants_for_own) === 0 && dataObj.forOwn) ? { display: "none" } : {}} />
                  <Tab label="Planung" style={(Number(access_rights.projects_planning_for_other) === 0 && dataObj.forOther) || (Number(access_rights.projects_planning_for_own) === 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_planning_for_own) === 0 && dataObj.forOwn) ? { display: "none" } : {}} />
                  <Tab label="Rechnungen" style={(Number(access_rights.projects_invoices_for_other) === 0 && dataObj.forOther) || (Number(access_rights.projects_invoices_for_own) === 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_invoices_for_own) === 0 && dataObj.forOwn) ? { display: "none" } : {}} />
                  {/* {project_data &&
                    project_data.project.dailyproof === 1 &&
                    <Tab label="Tätigkeiten" style={(Number(access_rights.projects_activity_for_other) === 0 && dataObj.forOther) || (Number(access_rights.projects_activity_for_own) === 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_activity_for_own) === 0 && dataObj.forOwn) ? { display: "none" } : {}} />
                  } */}
                </Tabs>
                <Prompt
                  when={dataObj.isBlocking}
                  message={location =>
                    `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                  }
                />
                <TabPanel
                  value={dataObj.currentTab}
                  index={0}>
                  {(Number(access_rights.projects_basedata_for_own) !== 0 || Number(access_rights.projects_basedata_for_other) !== 0) &&
                    <ProjectForm
                      textInput={this.textInput}
                      dataObj={dataObj}
                      handleFieldsChange={this.handleFieldsChange}
                      customer_list={customer_list}
                      branches_list={branches_list}
                      error_validation={dataObj.errorMessage}
                      user_list_for_pm={user_list_for_pm}
                      openDeleteDialog={this.openDeleteDialog}
                      createProject={this.createProject}
                    />
                  }
                </TabPanel>
                <TabPanel
                  value={dataObj.currentTab}
                  index={1}>
                  {project_data && ((Number(access_rights.projects_fee_for_other) !== 0 && dataObj.forOther) || (Number(access_rights.projects_fee_for_own) !== 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_fee_for_own) !== 0 && dataObj.forOwn)) &&
                    <SecondTab
                      consultant_list={consultant_list}
                      project_data={project_data.project}
                      ProjectFunctionsAndFee={dataObj.ProjectFunctionsAndFee}
                      error_validation={dataObj.errorMessage}
                      forOwn={dataObj.forOwn}
                      forOther={dataObj.forOther}
                      isBlockingCheck={this.isBlockingCheck}
                      isBlockingCheckfalse={this.isBlockingCheckfalse}
                      isInactive={!Boolean(dataObj.active)}
                    />
                  }
                </TabPanel>
                <TabPanel
                  value={dataObj.currentTab}
                  index={2}>
                  {project_data && ((Number(access_rights.projects_capacity_for_other) !== 0 && dataObj.forOther) || (Number(access_rights.projects_capacity_for_own) !== 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_capacity_for_own) !== 0 && dataObj.forOwn)) &&
                    <CapacityPlanning
                      project_data={project_data.project}
                      ProjectFunctionsAndFee={dataObj.ProjectFunctionsAndFee}
                      forOwn={dataObj.forOwn}
                      forOther={dataObj.forOther}
                      isBlockingCheck={this.isBlockingCheck}
                      isBlockingCheckfalse={this.isBlockingCheckfalse}
                      isInactive={!Boolean(dataObj.active)}
                    />
                  }
                </TabPanel>
                <TabPanel
                  value={dataObj.currentTab}
                  index={3}>
                  {project_data && ((Number(access_rights.projects_consultants_for_other) !== 0 && dataObj.forOther) || (Number(access_rights.projects_consultants_for_own) !== 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_consultants_for_own) !== 0 && dataObj.forOwn)) &&
                    <Consultants
                      project_data={project_data.project}
                      ProjectFunctionsAndFee={dataObj.ProjectFunctionsAndFee}
                      error_validation={dataObj.errorMessage}
                      forOwn={dataObj.forOwn}
                      forOther={dataObj.forOther}
                      isInactive={!Boolean(dataObj.active)}
                    />
                  }
                </TabPanel>
                <TabPanel
                  value={dataObj.currentTab}
                  index={4}>
                  {project_data && ((Number(access_rights.projects_planning_for_other) !== 0 && dataObj.forOther) || (Number(access_rights.projects_planning_for_own) !== 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_planning_for_own) !== 0 && dataObj.forOwn)) &&
                    <Planning
                      project_data={project_data.project}
                      updateProjectPlan={dataObj.ProjectFunctionsAndFee}
                      error_validation={dataObj.errorMessage}
                      forOwn={dataObj.forOwn}
                      forOther={dataObj.forOther}
                      isBlockingCheck={this.isBlockingCheck}
                      isBlockingCheckfalse={this.isBlockingCheckfalse}
                      isInactive={!Boolean(dataObj.active)}
                    />
                  }
                </TabPanel>
                <TabPanel
                  value={dataObj.currentTab}
                  index={5}>
                  {project_data && ((Number(access_rights.projects_invoices_for_other) !== 0 && dataObj.forOther) || (Number(access_rights.projects_invoices_for_own) !== 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_invoices_for_own) !== 0 && dataObj.forOwn)) &&
                    <Invoices
                      project_data={project_data.project}
                      error_validation={dataObj.errorMessage}
                      forOwn={dataObj.forOwn}
                      forOther={dataObj.forOther}
                      isInactive={!Boolean(dataObj.active)}
                    />
                  }
                </TabPanel>
                {/* <TabPanel
                  value={dataObj.currentTab}
                  index={6}>
                  {project_data && ((Number(access_rights.projects_activity_for_other) !== 0 && dataObj.forOther) || (Number(access_rights.projects_activity_for_own) !== 0 && !dataObj.forOther && !dataObj.forOwn) || (Number(access_rights.projects_activity_for_own) !== 0 && dataObj.forOwn)) &&
                    <Activity
                      project_data={project_data.project}
                      error_validation={dataObj.errorMessage}
                      forOwn={dataObj.forOwn}
                      forOther={dataObj.forOther}
                    />
                  }
                </TabPanel> */}
                {dataObj.errorMessage && dataObj.errorMessage.base &&
                  <div className="errorSpan">
                    <span>{dataObj.errorMessage.base}</span>
                  </div>
                }
                <div style={(Number(access_rights.projects_basedata_for_other) !== 2 && dataObj.forOther) || (Number(access_rights.projects_basedata_for_own) !== 2 && dataObj.forOwn) ?
                  { pointerEvents: "none", opacity: "0.4" } : {}}>

                </div>

                <Snackbar
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  open={dataObj.loginErrors}
                  autoHideDuration={6000}
                  severity="error"
                  message={login_error}
                />
                <Dialog
                  open={dataObj.isDeleteContactDialogOpen}
                >
                  <DialogTitle>Projekt löschen</DialogTitle>
                  <DialogContent>
                    <DialogContentText >
                      Sind Sie sicher?
              </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.deleteProject} size="small" variant="outlined" color="primary" autoFocus>
                      Bestätigen
              </Button>
                    <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary">
                      Abbrechen
              </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  open={!dataObj.hasPmAccess}
                >
                  <DialogContent>
                    <DialogContentText >
                      Dem Benutzer stehen nicht alle notwendigen Zugriffsrechte zur Verfügung
              </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => this.setState({ hasPmAccess: true })} size="small" variant="outlined" color="primary">
                      Trotzdem zuordnen
              </Button>
                    <Button onClick={() => this.setState({ hasPmAccess: true, projectmanager: dataObj.editMode ? project_data.project.project_manager_id : '' })} size="small" variant="outlined" color="secondary">
                      Abbrechen
              </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
          </div>
        </Container>
      </div >
    )
  }
}

const mapStateToProps = ({ projectsData, customer, branches, consultant, systems }) => {
  return {
    isloading: projectsData.loading,
    projects_list: projectsData.projects_list,
    user_list_for_pm: projectsData.user_list_for_pm,
    login_error: projectsData.login_error,
    forother_list: projectsData.forother_list,
    forown_list: projectsData.forown_list,
    project_data: projectsData.project_data,
    new_project: projectsData.new_project,
    edited_project: projectsData.edited_project,
    delete_success: projectsData.success,
    error_validation: projectsData.error_message,
    customer_list: customer.customerList,
    branches_list: branches.branches_list,
    consultant_list: consultant.consultant_list,
    system_settings: systems.system_settings,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetProjects: () => dispatch(GetProjects()),
    GetProjectData: (id) => dispatch(GetProjectData(id)),
    EditProject: (name) => dispatch(EditProject(name)),
    CreateNewProject: (data) => dispatch(CreateNewProject(data)),
    DeleteProject: (id) => dispatch(DeleteProject(id)),
    LogoutAction: () => dispatch(LogoutAction()),
    GetUserForManager: () => dispatch(GetUserForManager()),
    GetCustomer: () => dispatch(GetCustomer()),
    GetBranches: () => dispatch(GetBranches()),
    GetSystem: (project) => dispatch(GetSystem(project)),
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Projects))